import React, { useMemo } from 'react';
import SEO from '../SEO/SEO';
import JsonLd from '../JsonLd/JsonLd';
import MainNav from '../MainNav/MainNav';
import HeroSection from '../HeroSection/HeroSection';
import HomeStructuredContent from '../HomeStructuredContent/HomeStructuredContent';
import TechBanner from '../TechBanner/TechBanner';
import ServicesSection from '../ServicesSection/ServicesSection';
import CTASection from '../CTASection/CTASection';
import FinalCTASection from '../FinalCTASection/FinalCTASection';
import HomeSnakeGame from '../HomeSnakeGame/HomeSnakeGame';
import Footer from '../Footer/Footer';
import { HOME_SEO_FAQ } from '../../data/seoHomeFaq';
import { HOME_SERVICE_JSON_LD } from '../../data/homeServiceSchema';

const HomePage = ({ darkMode, toggleDarkMode }) => {
  const faqSchema = useMemo(
    () => ({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      url: 'https://e-asy.es/',
      mainEntity: HOME_SEO_FAQ.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    }),
    []
  );

  return (
    <>
      <SEO
        title="Software de gestión e IA para pymes y ONG en Tenerife | E-ASY"
        description="Software de gestión e IA para pymes y ONG en Tenerife. Del Excel al sistema en marcha: Vulpin Suite, Business Central u Odoo, o el que ya está, con ciberseguridad y la IA en producción."
        keywords="software de gestión pymes, software de gestión ONG, IA para empresas Tenerife, implantación ERP Tenerife, Odoo, Business Central, Vulpin Suite"
        canonical="https://e-asy.es"
      />
      <JsonLd id="jsonld-home-faq" data={faqSchema} />
      <JsonLd id="jsonld-home-service" data={HOME_SERVICE_JSON_LD} />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <main id="contenido-principal">
        <HeroSection darkMode={darkMode} />
        <HomeStructuredContent darkMode={darkMode} />
        <TechBanner darkMode={darkMode} />
        <ServicesSection darkMode={darkMode} />
        <CTASection darkMode={darkMode} />
        <FinalCTASection darkMode={darkMode} />
        <HomeSnakeGame darkMode={darkMode} />
      </main>
      <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default HomePage;
